import { createCodedError } from '~/common/errors/CodedError';
import { EsignatureType } from '~/enums/EsignatureType';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { testIsAxiosError } from '~/redux/api/utils';
import { everest } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

type Request = {
  ticketId: Uuid;
  recipientId: Uuid;
  vendor: EsignatureType;
};

type ServerRequest = {
  vendor: string;
  recipientId: Uuid;
};

export const sendReminder = async (request: Request): Promise<void> => {
  try {
    await everest.post(
      `tickets/${request.ticketId}/packages/remind`,
      mapRequest(request),
    );

    return;
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      const errorResponse = error.response.data.errors[0];
      throw createCodedError({
        message: errorResponse.detail ?? errorResponse.title,
        statusCode: errorResponse.status,
        title: errorResponse.title,
      });
    }

    throw error;
  }
};

const mapRequest = (request: Request): ServerRequest => {
  return {
    vendor: request.vendor.toUpperCase(),
    recipientId: request.recipientId,
  };
};
